import { FIND_RP_URLS } from "../constants/actionTypes";
import { PENDING, SUCCESS, ERROR } from "../constants/status";

const initialState = {
  isLoading: false,
  fetched: false,
  rpUrls: null,
  error: null,
};

export function findRpUrlsReducer(state = initialState, action) {
  const { type, response } = action;

  switch (type) {
    case `${FIND_RP_URLS}_${PENDING}`:
      return {
        ...state,
        isLoading: true,
        fetched: false,
        rpUrls: null,
        error: null,
      };

    case `${FIND_RP_URLS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        fetched: true,
        rpUrls: response?.data || [],
        error: null,
      };

    case `${FIND_RP_URLS}_${ERROR}`:
      return {
        ...state,
        isLoading: false,
        fetched: false,
        rpUrls: null,
        error: response?.message || "Failed to fetch RP URLs",
      };

    default:
      return state;
  }
}
